import { atom } from 'jotai';

export const alreadySentDraftsAtom = atom<Set<string>>(new Set<string>());
